module.exports = __webpack_public_path__ + "img/close-w.9fc84613.svg";